export default {
    updateOptions(state, payload) {
        state.options = payload;
    },

    updateFilter(state, payload) {
        state.filter = Object.assign(state.filter, payload);
    },

    updatePreview(state, payload) {
        state.preview = Object.assign({}, state.preview, payload);
    },

    updateDialogsVisible(state, payload) {
        state.dialogsVisible = Object.assign({}, state.dialogsVisible, payload);
    },
}